import {
  applicantSidebarMenuItems,
  employerSidebarMenuItems,
  enterPriseSidebarMenuItems,
  rokerboxSidebarMenuItems,
  adminSidebarMenuItems,
} from '@components/Layout/Sidebar/constants';
import { useEnterpriseGetNotifications } from '@features/enterpriseNotifications/hooks/useGetNotifications';
import { useGetNotifications } from '@features/notifications/hooks/useGetNotifications';
import { Check } from '@mui/icons-material';
import { authContext } from '@staffedupusa/shared-components';
import { getCookie } from '@utils/getCookie';
import { useContext } from 'react';

export const useGetSidebarMenuItems = (
  userType: 'employer' | 'enterprise' | 'rockerbox' | 'admin' | 'applicant',
) => {
  const { authData } = useContext(authContext);
   const inboxChecked = getCookie('inboxChecked');
  const { notificationsData } = useGetNotifications();
  const { enterpriseNotificationsData } = useEnterpriseGetNotifications({ count: true });

  function shouldTriggerWalkthrough() {
    if (!authData?.user) return false;

    const user = authData.user;
    const company = user?.company;

    const isIncomplete =
      authData?.user?.company?.plan === 4
        ? (!authData?.user?.has_shared_page ||
          !authData?.user?.has_image ||
          !inboxChecked ||
          !authData?.user?.company?.check_list?.has_visited_qualification_question_page ||
          !authData?.user?.company?.check_list?.has_visited_job_posting_page)
        : authData?.user?.company?.plan === 1
          ? (!authData?.user?.has_shared_page ||
            !authData?.user?.has_image ||
            !authData?.user?.company?.check_list?.has_visited_qualification_question_page ||
            !authData?.user?.company?.check_list?.has_visited_job_posting_page ||
            ((!authData?.user?.company?.check_list?.has_added_pre_qualification_questions ||
              !authData?.user?.calendar_count ||
              !authData?.user?.company?.auto_save_applications ||
              !authData?.user?.company?.auto_interview_invite) &&
              !authData?.user?.has_facebook_page_id))
          : authData?.user?.company?.plan === 2
            ? (!authData?.user?.has_shared_page ||
              !authData?.user?.has_image ||
              !authData?.user?.company?.check_list?.has_visited_qualification_question_page ||
              !authData?.user?.company?.check_list?.has_visited_job_posting_page ||
              ((!authData?.user?.company?.check_list?.has_added_pre_qualification_questions ||
                !authData?.user?.calendar_count ||
                !authData?.user?.company?.auto_save_applications ||
                !authData?.user?.company?.auto_interview_invite) &&
                !authData?.user?.has_facebook_page_id) ||
              (!authData?.user?.package_template &&
                !authData?.user?.has_mission_statement))
            : false;

    return isIncomplete && user.walkthrough_completed && authData?.user?.walkthrough_status !== 2;
  }

  const menuItems = (() => {
    switch (userType) {
      case 'employer':
        return [
          ...(shouldTriggerWalkthrough() ? [{
            text: 'Hiring Checklist',
            link: '/dashboard/?better-hiring=true',
            Icon: Check,
          }] : []),
          ...employerSidebarMenuItems
        ];
      case 'enterprise':
        return enterPriseSidebarMenuItems;
      case 'rockerbox':
        return rokerboxSidebarMenuItems;
      case 'admin':
        return adminSidebarMenuItems;
      case 'applicant':
        return applicantSidebarMenuItems;
      default:
        return [];
    }
  })();

  return menuItems.map((item) => {
    const inboxLink =
      userType === 'enterprise'
        ? '/enterprise/inbox/' :
        userType === 'applicant'
          ? '/applicants/inbox/'
          : userType === 'rockerbox'
            ? '/rockerbox/messages/'
            : '/inbox/';
    return item.link === inboxLink
      ? {
        ...item,
        badgeCount:
          userType === 'enterprise'
            ? enterpriseNotificationsData?.unread_thread_count || undefined
            : notificationsData?.unread_thread_count || undefined,
      }
      : item;
  });
};
